import { API_BASE_URL } from 'config'

import axios from 'axios'
import PropTypes from 'prop-types'
import first from 'lodash/first'
import sortBy from 'lodash/sortBy'
import AppLogic from 'containers/App/logic'

/** Redux and Kea **/
import { kea } from 'kea'
import { put, call } from 'redux-saga/effects'

const OfferTypesEndpoint = `${API_BASE_URL}/public/offer-type/`
const tensionTypeEndPoint = `${API_BASE_URL}/public/electricity-tension-type/`
const pressureTypeEndPoint = `${API_BASE_URL}/public/gas-tension-type/`

export default kea({

  actions: () => ({
    filter: (filter) => ({ filter }),
    fetchFilters: () => ({}),
    setFilters: (filters) => ({ filters }),
    setFetchError: (error) => ({ error }),
    fetchOptions: () => ({}),
    setOptions: (tension, pressure) => ({ tension, pressure }),
    setPressureOption: (option) => ({ option }),
    setTensionOption: (option) => ({ option }),
    clearOptions: () => ({})
  }),

  reducers: ({ actions }) => ({
    current: [null, PropTypes.any, {
      [actions.filter]: (_, payload) => payload.filter
    }],

    filters: [[], PropTypes.any, {
      [actions.setFilters]: (_, payload) => payload.filters
    }],

    options: [{}, PropTypes.any, {
      [actions.setOptions]: (_, {tension, pressure}) => ({
        tension, pressure
      })
    }],

    selectedTension: [null, PropTypes.any, {
      [actions.setTensionOption]: (_, payload) => payload.option.slug,
      [actions.filter]: (_, payload) => AppLogic.get('isCompany') ? null : 'btn'
    }],

    selectedPressure: [null, PropTypes.any, {
      [actions.setPressureOption]: (_, payload) => payload.option.slug,
      [actions.filter]: (_, payload) => AppLogic.get('isCompany') ? null : 'lp'
    }]
  }),

  start: function * () {
    const { fetchFilters, fetchOptions } = this.actions
    yield put(fetchOptions())
    yield put(fetchFilters())
  },

  takeLatest: ({ actions, workers }) => ({
    [actions.fetchFilters]: workers.fetchFilters,
    [actions.setFilters]: workers.filterByFirstResult,
    [actions.fetchOptions]: workers.fetchOptions
  }),

  workers: {
    /**
     * Fetches the filters
     * @param {Object} action Caller action
     */
    * fetchFilters (action) {
      const { setFilters, setFetchError } = this.actions
      const params = { limit: 100 }
      try {
        const request = yield call(axios.get, OfferTypesEndpoint, params)
        const sorted = sortBy(request.data.results, 'order')
        yield put(setFilters(sorted))
      } catch (error) {
        yield put(setFetchError(error))
      }
    },

    * fetchOptions () {
      try {
        const { setOptions } = this.actions
        const requestTension = yield call(axios.get, tensionTypeEndPoint, {})
        const requestPressure = yield call(axios.get, pressureTypeEndPoint, {})

        const mappedTension = requestTension.data.results.map((result) => ({
          value: result.id,
          label: result.name,
          slug: result.slug
        }))

        const mappedPressure = requestPressure.data.results.map((result) => ({
          value: result.id,
          label: result.name,
          slug: result.slug
        }))
        yield put(setOptions(mappedTension, mappedPressure))
      } catch (error) {

      }
    },

    /**
     * Filters by the first result
     */
    * filterByFirstResult () {
      const { filter } = this.actions
      const { filters } = this.props

      if (filters && !window.location.hash) {
        const { id, slug } = first(filters)
        yield put(filter({ id, slug }))
      }
    }
  }

})



// WEBPACK FOOTER //
// ./src/containers/Filters/logic.js